import { render, staticRenderFns } from "./InboxContents.vue?vue&type=template&id=d82c1e20&scoped=true"
import script from "./InboxContents.vue?vue&type=script&lang=js"
export * from "./InboxContents.vue?vue&type=script&lang=js"
import style0 from "./InboxContents.vue?vue&type=style&index=0&id=d82c1e20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d82c1e20",
  null
  
)

export default component.exports